<template>
  <main class="l-container">
    <div class="l-container__inner">
      <slot name="body"></slot>
    </div>

    <div class="l-container__breadArea">
      <common-breadcrumb v-if="isBread" :heading="breadHeading" :breadcrumbType="'default'"  />
    </div>
  </main>
</template>

<script>
import MixinAPI from '@/plugins/mixin-api';
import IsMobile from '@/plugins/isMobile';
import CommonBreadcrumb from '@/components/parts/CommonBreadcrumb';
import CommonButton from '@/components/parts/button/CommonButton';
import CommonSelect from '@/components/parts/select/CommonSelect';


export default {
  name: 'CommonLayoutHistoryTemplate',
  mixins: [MixinAPI, IsMobile],
  props: ['title', 'isBread', 'breadHeading'],
  components: {
    CommonBreadcrumb,
    CommonButton,
    CommonSelect,
  },
  data() {
    return {
      isMobile: false,
      isTablet: false,
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
// brake points 768px(tablet)/639px(sp)
@charset "UTF-8";
.l-container {
  padding: 24px 20px 0;
  flex: 1 0 auto;
  background: #fafafa;

  &__inner {
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
  }
  &__breadArea {
    max-width: 720px;
    margin: 0 auto;

    .c-bread {
      width: 100%;
      padding: 20px 0;
      margin: 0;
    }
  }
}

@media screen and (max-width: 768px) {
  .l-container {
    &__inner {
      margin-bottom: 20px;
    }
  }
}

@media screen and (max-width: 639px) {
  .l-container {
    &__inner {
      padding: 0;
      margin-top: 0;
      margin-bottom: 20px;
      border-radius: 0;
      border: 0;
      background: #fafafa;
    }
  }
}

</style>
